/* ★ POPUP "SAHKAN SEMUA KAD + MY PRODUCTS" (2026-10-06, lakaran diluluskan user).
 *
 * Muncul bila pelanggan menekan Simpan dalam borang Product Data yang dibuka dari KAD
 * Workspace, dengan skop "Semua kad + My Products", DAN ada kad lain yang akan terkena.
 * Sebabnya: skop itu lalai, jadi pelanggan yang hanya mahu membetulkan SATU kad boleh
 * tersimpan ke My Products + semua kad produk itu tanpa sedar. Popup ini menunjukkan
 * bilangan sebenar tempat yang berubah, dan butang "Kad ini sahaja" menyelamatkannya
 * dengan satu klik (tanpa menutup popup dan memilih semula).
 *
 * RUPA SAHAJA — tiada tulisan pangkalan data di sini. Pemanggil (CompleteProductDataModal)
 * yang menyimpan mengikut butang yang ditekan. Dirender melalui portal ke <body> di atas
 * borang (borang z-index 3000). Token v3.9 dengan nilai sandaran, corak PopupRunDitahan.
 *
 * bilKadLain: nombor kad LAIN (tidak termasuk kad ini) — atau null bila kiraan gagal
 *             ("tidak diketahui"): popup tetap muncul, ayatnya tanpa nombor.
 * itemBaru:   true bila Simpan akan MENCIPTA item My Products (kes System / Baru).
 */
import React, { useEffect } from 'react';
import { createPortal } from 'react-dom';

const ID_TAJUK = 'popup-sahkan-semua-kad-tajuk';

export default function PopupSahkanSemuaKad({ buka, bilKadLain = null, itemBaru = false, onSemua, onKadSahaja, onBatal, T }) {
    // Escape = Batal. Hook WAJIB sebelum pulangan awal (peraturan hooks React).
    useEffect(() => {
        if (!buka) return undefined;
        const kekunci = (e) => { if (e.key === 'Escape') { e.stopPropagation(); onBatal?.(); } };
        window.addEventListener('keydown', kekunci, true);
        return () => window.removeEventListener('keydown', kekunci, true);
    }, [buka, onBatal]);

    if (!buka || typeof document === 'undefined') return null;

    const diketahui = Number.isInteger(bilKadLain) && bilKadLain >= 0;
    // My Products (1) + kad ini (1) + kad lain.
    const bilTempat = diketahui ? bilKadLain + 2 : null;
    /* Label butang WAJIB menyebut APA yang berubah (aduan user 2026-10-06: "Ya, ubah semua" —
       "semua tu kat mana?"). Butang menamakan My Products + bilangan kad sebenar (kad ini + kad lain). */
    const bilKad = diketahui ? bilKadLain + 1 : null;
    const labelSemua = itemBaru
        ? (diketahui
            ? T('products.complete.sah.yaBaru', `Tambah ke My Products + ubah semua ${bilKad} kad`, { n: bilKad })
            : T('products.complete.sah.yaBaruSemua', 'Tambah ke My Products + ubah semua kad produk ini'))
        : (diketahui
            ? T('products.complete.sah.ya', `Ubah My Products + semua ${bilKad} kad`, { n: bilKad })
            : T('products.complete.sah.yaSemua', 'Ubah My Products + semua kad produk ini'));

    const baris = (ikon, teks) => (
        <div style={{ display: 'flex', alignItems: 'center', gap: 10, padding: '10px 12px', borderRadius: 10, background: 'var(--s-fill, rgba(0,0,0,.04))' }}>
            <span className="material-symbols-outlined" aria-hidden style={{ flex: 'none', fontSize: 18, color: 'var(--s-ink-2, #696969)' }}>{ikon}</span>
            <span style={{ minWidth: 0, fontSize: 13.5, lineHeight: 1.4 }}>{teks}</span>
        </div>
    );
    const gayaButang = { width: '100%', height: 38, padding: '0 16px', borderRadius: 10, fontFamily: 'inherit', fontSize: 13, fontWeight: 600, cursor: 'pointer' };

    return createPortal(
        <div
            role="presentation"
            onClick={() => onBatal?.()}
            style={{ position: 'fixed', inset: 0, zIndex: 10050, background: 'rgba(0,0,0,.62)', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 16 }}
        >
            {/* `s-root` WAJIB: popup di-portal ke <body>, di LUAR pokok .s-root — tanpanya ia hilang
                muka taip v3.9 (keluar muka taip lalai body) dan tidak sepadan dengan borang di belakangnya. */}
            <div
                className="s-root"
                role="dialog"
                aria-modal="true"
                aria-labelledby={ID_TAJUK}
                onClick={(e) => e.stopPropagation()}
                style={{
                    boxSizing: 'border-box', width: '100%', maxWidth: 420, maxHeight: 'calc(100vh - 32px)', overflowY: 'auto',
                    padding: 20, display: 'flex', flexDirection: 'column', gap: 14,
                    background: 'var(--s-panel, #ffffff)', color: 'var(--s-ink, #262626)',
                    border: '1px solid var(--s-line, rgba(0,0,0,.08))', borderRadius: 'var(--s-r-lg, 16px)',
                    boxShadow: 'var(--s-shadow-modal, 0 24px 64px -20px rgba(0,0,0,.25))',
                }}
            >
                <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                    <span style={{ flex: 'none', width: 34, height: 34, borderRadius: 999, display: 'inline-flex', alignItems: 'center', justifyContent: 'center', background: 'var(--s-fill, rgba(0,0,0,.04))', color: 'var(--s-ink-2, #696969)' }}>
                        <span className="material-symbols-outlined" aria-hidden style={{ fontSize: 19 }}>sync_alt</span>
                    </span>
                    <h3 id={ID_TAJUK} style={{ margin: 0, fontSize: 16, fontWeight: 600, lineHeight: 1.35 }}>
                        {diketahui
                            ? T('products.complete.sah.tajuk', `Perubahan ini melibatkan ${bilTempat} tempat`, { n: bilTempat })
                            : T('products.complete.sah.tajukSemua', 'Perubahan ini melibatkan My Products dan semua kad produk ini')}
                    </h3>
                </div>

                <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
                    {baris('inventory_2', itemBaru
                        ? T('products.complete.sah.itemBaru', 'Item baharu ditambah ke My Products')
                        : T('products.complete.sah.item', 'Item ini dalam My Products'))}
                    {baris('style', diketahui
                        ? T('products.complete.sah.kad', `Kad ini + ${bilKadLain} kad lain produk yang sama`, { n: bilKadLain })
                        : T('products.complete.sah.kadSemua', 'Kad ini dan semua kad lain produk yang sama'))}
                </div>

                <p style={{ margin: 0, fontSize: 12.5, lineHeight: 1.5, color: 'var(--s-ink-2, #696969)' }}>
                    {T('products.complete.sah.nota', 'Gambar, link, harga dan data produk pada semua tempat di atas akan diganti. Nama kad lain tidak berubah.')}
                </p>

                <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
                    <button
                        type="button"
                        onClick={() => onSemua?.()}
                        style={{ ...gayaButang, border: '1px solid var(--s-primary, #262626)', background: 'var(--s-primary, #262626)', color: 'var(--s-primary-ink, #FAFAFA)' }}
                    >
                        {labelSemua}
                    </button>
                    <button
                        type="button"
                        onClick={() => onKadSahaja?.()}
                        style={{ ...gayaButang, border: '1px solid var(--s-line-strong, rgba(0,0,0,.14))', background: 'transparent', color: 'var(--s-ink, #262626)' }}
                    >
                        {T('products.complete.sah.kadSahaja', 'Ubah kad ini sahaja')}
                    </button>
                    <button
                        type="button"
                        autoFocus
                        onClick={() => onBatal?.()}
                        style={{ ...gayaButang, border: '1px solid transparent', background: 'transparent', color: 'var(--s-ink-2, #696969)', fontWeight: 500 }}
                    >
                        {T('common.cancel', 'Batal')}
                    </button>
                </div>
            </div>
        </div>,
        document.body,
    );
}
